import { type ClientRectObject, FloatingOverlay } from "@floating-ui/react";
import type { CSSProperties, FC } from "react";

import { Spotlight, type SpotlightStyle } from "./Spotlight";

interface OverlayProps {
  onClick?: () => void;
  overlayStyle?: CSSProperties;
  rect: ClientRectObject | undefined;
  spotlightStyle?: SpotlightStyle;
  zIndex?: number;
}

export const Overlay: FC<OverlayProps> = ({
  overlayStyle,
  rect,
  zIndex,
  onClick,
  spotlightStyle,
}) => {
  return (
    <FloatingOverlay
      onClick={onClick}
      style={{
        mixBlendMode: "hard-light",
        backgroundColor: "rgba(0, 0, 0, .5)",
        ...overlayStyle,
        zIndex,
      }}
    >
      <Spotlight rect={rect} style={spotlightStyle} />
    </FloatingOverlay>
  );
};
